import { FC } from 'react';
import styles from './RequestActionModal.module.css';
import iconFamilyGroup from '../../../../../assets/img/icons/family-group-request.png';
import iconClose from '../../../../../assets/img/icons/close-icon.png';

interface RequestActionModalProps {
    isOpen: boolean;
    onClose: () => void;
    onAccept: () => void;
    onReject: () => void;
    requestInfo: {
        applicantName: string;
        relationship: string;
    };
}

export const RequestActionModal: FC<RequestActionModalProps> = ({
    isOpen,
    onClose,
    onAccept,
    onReject,
    requestInfo
}) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modal}>
            <div className={styles.modalContent}>
                <div className={styles.modal__header}>
                    <img src={iconClose} alt="Cerrar" onClick={onClose} className={styles.modal__close} />
                </div>

                <div className={styles.modal__body}>
                    <img src={iconFamilyGroup} alt="Grupo familiar" className={styles.modal__body__icon} />
                    <h4 className={styles.modal__body__title}>Solicitud de grupo familiar</h4>
                    <p className={styles.modal__body__subtitle}>{requestInfo.applicantName} te ha enviado una solicitud para agregarte a su grupo familiar.</p>
                    <div className={styles.modal__body__actions}>
                        <button onClick={onAccept} className={`${styles.modalActions__button} ${styles.modalActions__button__accept}`}>Aceptar</button>
                        <button onClick={onReject} className={`${styles.modalActions__button} ${styles.modalActions__button__reject}`}>Rechazar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}; 